// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__UIce3","hiddenElements":"Header_hiddenElements__u9lPu","search":"Header_search__3575r","dark":"Header_dark__1i1a0","wrapper":"Header_wrapper__3aWO8"};